import { render, staticRenderFns } from "./CFormAttachment.vue?vue&type=template&id=58891c9d&scoped=true&"
import script from "./CFormAttachment.vue?vue&type=script&lang=js&"
export * from "./CFormAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58891c9d",
  null
  
)

export default component.exports